// src/components/ui/GinoriDivider.tsx
import React from 'react';
import { Divider, DividerProps, Box } from '@mantine/core';

interface GinoriDividerProps extends DividerProps {
  elegant?: boolean;
  withIcon?: React.ReactNode;
}

export function GinoriDivider({ 
  elegant = false, 
  withIcon,
  ...props 
}: GinoriDividerProps) {
  if (elegant) {
    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '2rem 0',
        }}
      >
        <Box
          style={{
            width: '100%',
            height: '1px',
            background: 'linear-gradient(to right, transparent, var(--mantine-color-ginoriGold-4), transparent)',
          }}
        />
        {withIcon && (
          <Box
            style={{
              position: 'absolute',
              backgroundColor: 'var(--mantine-color-white)',
              padding: '0.5rem',
              color: 'var(--mantine-color-ginoriGold-6)',
            }}
          >
            {withIcon}
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Divider
      style={{
        borderColor: 'var(--mantine-color-ginoriNeutral-3)',
        '&::before, &::after': {
          borderTopColor: 'var(--mantine-color-ginoriNeutral-3)',
        },
      }}
      {...props}
    />
  );
}
